import { z } from "zod";
import { UserRole } from "../schemas";
const tenantId = z.string().regex(/^[A-Za-z0-9_-]{1,128}$/);
export const SessionContextSchema = z
  .object({
    actor: z
      .object({
        id: z.string().uuid(),
        clerkId: z.string().trim().min(1).max(256),
        homeTenantId: tenantId,
        role: UserRole,
      })
      .strict(),
    effectiveTenant: z
      .object({ id: tenantId, name: z.string().trim().min(1).max(500) })
      .strict(),
    context: z.enum(["HOME", "OPERATOR"]),
  })
  .strict()
  .superRefine((value, ctx) => {
    const home = value.actor.homeTenantId === value.effectiveTenant.id;
    if (
      (value.context === "HOME") !== home ||
      (!home && value.actor.role !== "SYSTEM_ADMIN")
    )
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Contradictory organization context",
      });
  });
export type SessionContext = z.infer<typeof SessionContextSchema>;
